import { render, staticRenderFns } from "./FacilityAdd.vue?vue&type=template&id=b93720aa"
import script from "./FacilityAdd.vue?vue&type=script&lang=js"
export * from "./FacilityAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports